<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-shopping-cart"></i> ใบสั่งซื้อ</h4>

          <div class="d-flex align-items-center mx-1 my-3">
            <b-form-input
              type="search"
              class="flex-grow-1"
              autofocus
              v-model="filter"
              placeholder="ค้นหาใบสั่งซื้อ จากรหัสใบสั่งซื้อ หรือรหัสใบขอซื้ออ้างอิง"
            ></b-form-input>
          </div>

          <b-table
            id="purchaseOrderTable"
            ref="purchaseOrderTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="sortedPurchaseOrderList"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="['poCode', 'prRefCode']"
            sort-by="createdAt"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(status)="row">
              <PoStatusBadge :status="row.value" />
            </template>
            <template v-slot:cell(prRefCode)="row">
              <span
                v-if="row.item.prRefCodes && row.item.prRefCodes.length > 0"
                class="pr-list"
              >
                <span
                  v-for="code in row.item.prRefCodes"
                  :key="code"
                  >{{ code }}</span
                >
              </span>
              <span
                v-else
                class="font-weight-medium text-muted"
                >-</span
              >
            </template>
            <template v-slot:cell(createdAt)="row">
              {{ formatDate(row.value) }}
            </template>
            <template v-slot:cell(buttons)="row">
              <ActionButtonGroup
                :item="row.item"
                :show-edit="false"
                :show-delete="false"
                infoTooltip="ดูข้อมูลใบสั่งซื้อ"
                @info="goToDetail(row.item)"
              />
            </template>
          </b-table>
        </div>
      </div>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import PoStatusBadge from "../../components/badge/PoStatusBadge.vue";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import { THAI_MONTHS } from "@/constants";
import Loading from "@/components/Loading";

export default {
  name: "PurchaseOrder",
  components: {
    PoStatusBadge,
    ActionButtonGroup,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "4%" },
          tdClass: "index-cell",
        },
        {
          key: "status",
          label: "สถานะ",
          sortable: true,
          thStyle: { width: "16%", whiteSpace: "nowrap" },
        },
        {
          key: "poCode",
          label: "รหัสใบสั่งซื้อ",
          sortable: true,
          thStyle: { width: "24%", whiteSpace: "nowrap" },
        },
        {
          key: "prRefCode",
          label: "รหัสใบขอซื้ออ้างอิง",
          sortable: true,
          thStyle: { width: "24%", whiteSpace: "nowrap" },
        },
        {
          key: "createdAt",
          label: "วันที่สร้าง",
          sortable: true,
          sortDirection: "desc",
          thStyle: { width: "18%", whiteSpace: "nowrap" },
        },
        {
          key: "buttons",
          label: "",
          thStyle: { width: "6%" },
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getPurchaseOrderList: "modulePurchaseOrder/getPurchaseOrderList",
      getPoFilter: "modulePurchaseOrder/getPoFilter",
    }),
    filter: {
      get() {
        return this.getPoFilter;
      },
      set(value) {
        this.$store.commit("modulePurchaseOrder/setFilter", value);
      },
    },
    sortedPurchaseOrderList() {
      return [...this.getPurchaseOrderList].sort((a, b) => {
        const dateDiff = new Date(b.createdAt) - new Date(a.createdAt);
        if (dateDiff !== 0) return dateDiff;
        return b.poCode.localeCompare(a.poCode, undefined, { numeric: true });
      });
    },
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrderList: "modulePurchaseOrder/fetchPurchaseOrderList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchPurchaseOrderList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการใบสั่งซื้อไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    goToDetail(purchaseOrder) {
      this.$router.push({
        name: "PurchaseOrderDetail",
        params: {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: purchaseOrder.id,
        },
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const day = date.getDate();
      const month = THAI_MONTHS[date.getMonth()];
      const year = String(date.getFullYear()).slice(-2);
      return `${day} ${month} ${year}`;
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped>
::v-deep #purchaseOrderTable {
  table-layout: auto;
}

::v-deep #purchaseOrderTable thead th {
  padding: 16px 24px;
}

::v-deep #purchaseOrderTable tbody td {
  padding: 16px 24px;
  vertical-align: middle;
}

::v-deep .index-cell {
  white-space: nowrap;
}

.pr-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

@media (max-width: 576px) {
  ::v-deep #purchaseOrderTable thead th,
  ::v-deep #purchaseOrderTable tbody td {
    padding: 10px 12px;
  }
}
</style>
